<app-header></app-header>
<div class="landing-content" id="landing-page-scroll"  (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
    <div class="scroll-loader-wrap" *ngIf="showScrollLoader && util.isMobile ">
        <div class="scroll-loader animate"></div>
    </div>
    <router-outlet></router-outlet>
    <app-footer [showFooterMain]=" isLandingScreen || util.showFooter" [showFooterSecondary]="isLoginScreen || isLandingScreen || util.showFooter"></app-footer>
</div>
